import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { t as n } from "../internals/to-indexed-object.js";
import { t as o } from "../internals/to-object.js";
import { t as i } from "../internals/to-string.js";
import { l as s } from "../internals/length-of-array-like.js";
var a = t([].push),
  e = t([].join);
r({
  target: "String",
  stat: !0
}, {
  raw: function raw(r) {
    var t = n(o(r).raw),
      f = s(t);
    if (!f) return "";
    for (var m = arguments.length, l = [], j = 0;;) {
      if (a(l, i(t[j++])), j === f) return e(l, "");
      j < m && a(l, i(arguments[j]));
    }
  }
});